(function () {
  function initCard(card) {
    if (card.dataset.enhanced) return;
    card.dataset.enhanced = 'true';

    var storeId = card.dataset.storeId;
    var productId = card.dataset.productId;
    var thumb = card.querySelector('.pdp-gallery-ugc-card__thumb');
    var url = `https://storefront-api.loox.io/storefront/v1/store/${storeId}/product-reviews?product_id=${productId}&limit=25`;

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`Loox request failed: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        let photoUrl = null;
        (data.reviews || []).some((review) =>
          (review.media || []).some((item) => {
            if (item.type === 'photo' && item.url) {
              photoUrl = item.url;
              return true;
            }
            return false;
          })
        );

        if (!photoUrl) return;

        thumb.src = photoUrl;
        card.hidden = false;
      })
      .catch((error) => {
        console.error('[pdp-gallery-ugc-card]', error);
      });
  }

  document.querySelectorAll('.pdp-gallery-ugc-card').forEach(initCard);
})();
